import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues, { formatReceived, hasFiles } from 'utils/formatValues';

export const baseURI = '/recaudacion/registros-de-beneficiarios/';
const files = ['documento_de_identificacion',
  'documento_autorizacion_de_oficio',
  'documento_oficio_poder'];
const headers = { 'Content-Type': 'multipart/form-data' };

/**
 * GET Registros De Beneficiarios
 * @returns {Promise<Array<object>>}
 */
export const getRegistrosDeBeneficiarios = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Registro De Beneficiario
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getRegistroDeBeneficiario = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Registro De Beneficiario
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postRegistroDeBeneficiario = async (values) => {
  try {
    const config = hasFiles(values, files) ? { headers } : {};
    const formattedValues = getFormattedValues(values, {
      files,
      formData: config.headers,
      clean: true,
    });
    const response = await API.post(baseURI, formattedValues);
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Registro De Beneficiario
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchRegistroDeBeneficiario = async (id, values) => {
  try {
    const config = hasFiles(values, files) ? { headers } : {};
    const formattedValues = getFormattedValues(values, {
      files,
      formData: config.headers,
      clean: true,
    });
    const response = await API.patch(`${baseURI}${id}`, formattedValues);
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Registro De Beneficiario
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteRegistroDeBeneficiario = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
